/**
 * @file 包含常用方法的公共实例
 * @author 李小龙
 * @date 2018/5/31
 */

import axios from 'axios'
import qs from 'qs'
import apis from './apis'
import { Loading } from 'element-ui'
import { debounce, formatToDate } from './util'
import { getSign } from './NewMD5Encrypt'

window.qs = qs

axios.interceptors.request.use(
  function(config) {
    if (config.loader != null) {
      config.loadingInstance = Loading.service({ target: config.loader })
    }
    if (sessionStorage.token) {
      config.headers.token = sessionStorage.token
    }
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  res => {
    if (res.config.loadingInstance) res.config.loadingInstance.close()
    if (res.headers && res.headers['new-token']) {
      console.log('更换newToken:' + res.headers['new-token'])
      sessionStorage.setItem('token', res.headers['new-token'])
    }
    if (res.headers && res.headers['content-disposition']) {
      sessionStorage.setItem('disposition', res.headers['content-disposition'])
    }
    if (typeof res.data === 'string' || res.data instanceof Blob)
      return res.data
    if (res.data.code == 1)
      return res.data
    else {
      if (res.data.code == 20051) {
        debounce(
          'appjs',
          () => {
            vm.$message.error('未登录！')
            setTimeout(() => {
              sessionStorage.clear()
              location.href = "/"
            }, 2000)
          },
          2000
        )
      } else if (res.data.code == 20053) {
        debounce(
          'appjs',
          () => {
            vm.$message.error('会话超时，请重新登录！')
            setTimeout(() => {
              sessionStorage.clear()
              location.href = "/"
            }, 2000)
          },
          2000
        )
      } else if (res.data.code == 20003) {
        loginVm.loginError = true
      } else {
        vm.$message.error(res.data.responseMessage || res.data.message)
      }
      return Promise.reject(res.data)
    }
  },
  e => {
    window.error = e
    if (e.config && e.config.loadingInstance) e.config.loadingInstance.close()
    if (e.response) {
      if (e.response.data && e.response.data.message)
        vm.$message.error(e.response.data.message)
    } else if (e.request) {
      vm.$message.error('服务器无响应')
    }
    return Promise.reject(e)
  }
)

export default {
  /** ajax get */
  get(url, data, loader) {
    if (apis[url] == null) {
      console.error('接口路径未配置：' + url)
      return
    }
    //管理员时orgId是手动选择的
    if (sessionStorage.loginInfo && JSON.parse(sessionStorage.loginInfo).orgId != null)
      Object.assign(data, {orgId: JSON.parse(sessionStorage.loginInfo).orgId})
    data.sign = getSign(data)
    return axios.get(apis[url], { params: data, loader: loader })
  },

  /** ajax post */
  post(url, data, loader, formData) {
    if (apis[url] == null) {
      console.error('接口路径未配置：' + url)
      return
    }
    if (sessionStorage.loginInfo && JSON.parse(sessionStorage.loginInfo).orgId != null)
      Object.assign(data, {orgId: JSON.parse(sessionStorage.loginInfo||'{}').orgId})
    data.sign = getSign(data)
    //使用query而非body（后端问题）
    return axios.post(apis[url], formData, {
      loader: loader,
      params: data,
    })
  },

  /** 获取当前登录用户对象 */
  getUser() {
    return JSON.parse(localStorage.user || '{}')
  },

  /** 获取今天日期的字符串 */
  getTodayString() {
    return formatToDate(new Date())
  },
  /** 获取上个月今天日期的字符串 */
  getLastMonthString() {
    var lastMonth = new Date()
    lastMonth.setMonth(lastMonth.getMonth() - 1)
    return formatToDate(lastMonth)
  },

  /** 存储对象键的枚举 */
  stores: {
    /** 上次登录记住的用户名密码 */
    LastLogin: 'lastLogin'
  },
  /** 获取对象 */
  getStore(key) {
    return JSON.parse(localStorage.getItem('store-' + key) || '{}')
  },
  /** 移除存储的对象 */
  removeStore(key) {
    localStorage.removeItem('store-' + key)
  },
  /** 存储对象 */
  setStore(key, value) {
    localStorage.setItem('store-' + key, JSON.stringify(value || {}))
  },
  /** 获取按钮权限 */
  getButtons(name) {
    if (window.menuNameToId[name] == null) return Promise.resolve([])
    return this.post('页面按钮权限', {userId: JSON.parse(sessionStorage.loginInfo||'{}').id, resId: window.menuNameToId[name]}).then(d => d.data.map(item => { if (item.flag ==1) return item.name }))
  },
  /** 获取登录信息 */
  getLogin() {
    return JSON.parse(sessionStorage.loginInfo||'{}')
  },
  /** 获取平台信息 */
  getPlatformId() {
    return this.getLogin().platformId
  },
}



// WEBPACK FOOTER //
// ./src/js/app.js